import { Component, Input } from "@angular/core";
import { Community, MembershipListConfig } from "../../../../models";

@Component({
  selector: "show-members-button",
  templateUrl: "./show-members-button.component.html",
  styleUrls: [
    "./show-members-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class ShowMembersButtonComponent {
  @Input() community: Community;
  @Input() limit: number;
  @Input() config: MembershipListConfig;

  constructor() {}
}
